






















import { Component, Prop, Vue } from 'vue-property-decorator'
import * as graph from '@shared/types/graphql'
import ClientUploadInput from '@/components/ClientUploads/ClientUploadInput.vue'

@Component({
  components: {
    ClientUploadInput
  }
})
export default class ClientUploadInputs extends Vue {
  @Prop({ required: true }) uploads!: graph.Prototype[]
  @Prop({ required: true }) shownErrors!: Record<string, string[]>

  errors: Record<string, string[]> = {}

  get uniqueErrors (): string[] {
    const errors = []
    for (const key in this.shownErrors) {
      errors.push(...this.shownErrors[key])
    }
    return [...new Set(errors)]
  }

  setErrors (errors: Record<string, string[]>) {
    this.$emit('fieldsValidated', errors)
  }

  removeUpload (id: string) {
    this.shownErrors[id] = []
    this.$emit('removeUpload', id)
  }
}

